
import * as Components from "./Losamigosall"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "losamigosall"
}

